import {
  FieldWrapper,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@commenda/kakashi';
import { WorkflowDemoEmailType, TDemoEmailStepDefinition } from '@commenda/types';
import { useWorkflow } from '../../context/WorkflowContext';
import { TSelectedEntity } from '../../types/node';

const EMAIL_TYPE_OPTIONS = [
  { value: WorkflowDemoEmailType.VAT_NOTICE, label: 'VAT Notice' },
  { value: WorkflowDemoEmailType.SERVICE_COMPLETION, label: 'Service Completion' },
];

// DEMO ONLY - Do not use in production
export const DemoEmailNodePropertyPanel = ({
  selectedEntity,
}: {
  selectedEntity: TSelectedEntity;
}) => {
  const { workflow, setWorkflow } = useWorkflow();

  const selectedStep = workflow?.steps.find(
    (step) => step.id === selectedEntity.id
  ) as TDemoEmailStepDefinition | undefined;

  if (!selectedStep) return <div>Step not found</div>;

  const emailConfig = selectedStep.email ?? { emailType: undefined };

  const updateEmailConfig = (
    updates: Partial<TDemoEmailStepDefinition['email']>
  ) => {
    setWorkflow({
      ...workflow,
      steps: workflow?.steps.map((step) =>
        step.id === selectedEntity.id
          ? { ...step, email: { ...emailConfig, ...updates } }
          : step
      ),
    });
  };

  return (
    <div className="flex flex-col gap-4">
      <FieldWrapper>
        <Label>Email Type</Label>
        <Select
          value={emailConfig.emailType || ''}
          onValueChange={(value) =>
            updateEmailConfig({ emailType: value as WorkflowDemoEmailType })
          }
        >
          <SelectTrigger>
            <SelectValue placeholder="Select an email type" />
          </SelectTrigger>
          <SelectContent>
            {EMAIL_TYPE_OPTIONS.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </FieldWrapper>
    </div>
  );
};
